module.exports = __webpack_public_path__ + "media/images/360/CBD_facts_woman_on_bed-90c1f25e38233fd791b166ac8486ff8b.jpg";